import React, { useRef, useState } from 'react'
import emailjs from 'emailjs-com'

const Contact = () => {
    const form = useRef()

  const [data, updateData] = useState({
    Name: "",
    Email: '',
    Number: '',
    Subject: '',
    Message: ''
  })
  const { Name, Email, Number, Subject, Message } = data;

  const changeHandler = e => {
    updateData({ ...data, [e.target.name]: [e.target.value] })

  }
  const submitHandler = e => {
    e.preventDefault();

    emailjs.sendForm('service_d7nkc98', 'template_dhs0a87', e.target, '-_ajGXvF0DTOYDkQE')
      .then((result) => {
        alert("message Sent Succesfully")
        updateData({
          Name: "",
          Email: "",
          Number: "",
          Subject: '',
          Message: ''

        })

      }, (error) => {
        console.log(error.text);
      });

  }
    return (
        <>
            <div className="container-fluid strips " id="strip" style={{ display: 'flex', backgroundColor: "#0899ff" }}>
                <div className="col text-center strip1" style={{ color: 'white' }}>
                    <div className="row mt-5 mb-5" >
                        <h1 style={{ textTransform: 'uppercase' }}>Contact</h1>
                    </div>
                </div>
            </div>
            <div className='custom-container my-5' >
                <div className='row'>
                    <div className='col-md-6'>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3829.4694991972938!2d80.4565882!3d16.298937700000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4a0be50b23ece3%3A0x2735b9d88b753ded!2sDr%20Garlapati%20Siva%20Srikar!5e0!3m2!1sen!2sin!4v1776162289227!5m2!1sen!2sin" width="100%" height="100%" style={{ border: "2px solid #0899ff",borderRadius:"5px 5px 5px 5px" }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" ></iframe>
                    </div>
                    <div className='col-md-6'>
                        <div >
                            <h1 style={{ textAlign: 'center', fontSize: '26px !important', fontFamily: 'Roboto, sans-serif', color: '#0899ff', fontWeight: 'bold', marginBottom: '15px' }}>
                                <span style={{ color: "#0899ff" }}>MESSAGE US</span>
                            </h1>
                            <h3 style={{ textAlign: 'center', fontSize: '26px !important', fontFamily: 'Roboto, sans-serif', color: '#0899ff', fontWeight: 'bold', marginBottom: '15px' }}>
                                <span style={{ color: "black" }}><b>Drop Us Message For Any Query</b></span>
                            </h3>

                            {/* form submission .......*/}
                            <form ref={form} onSubmit={submitHandler}>
                                <div className="container border w-100 m-auto p-3 " style={{ borderRadius: '20px' }}  >
                                    <div className="row" >
                                        <div className="col-lg-6 my-3 ">
                                            <div className="form-group ">
                                                <input type="text" value={Name} onChange={changeHandler} className="form-control" title='' placeholder="Your Name" name="Name" required="Username is Required..." message="Username must be atmost 30 characters long..." style={{ padding: '10px' }} />
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 my-3 ">
                                            <div className="form-group">
                                                <input type="email" value={Email} onChange={changeHandler} className="form-control" title='' placeholder="Your Email Address" name="Email" id="email" required="Email is required" data-error="Please enter your email" fdprocessedid="p2hd6j" style={{ padding: '10px' }} />
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 my-3">
                                            <div className="form-group">
                                                <input type="text" value={Number} onChange={changeHandler} className="form-control" title='' name="Number" placeholder="Phone Number" id="phone_number" required="Number is Required" data-error="Please enter your number" fdprocessedid="cf7ig" style={{ padding: '10px' }} />
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 my-3">
                                            <div className="form-group">
                                                <input type="text" value={Subject} onChange={changeHandler} className="form-control" title='' name="Subject" placeholder="Subject" id="msg_subject" required="Subject is Required" data-error="Please enter your subject" fdprocessedid="4mor3e" style={{ padding: '10px' }} />
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 my-3">
                                            <div className="form-group">
                                                <textarea name="Message" value={Message} onChange={changeHandler} className="form-control" id="message" cols="30" rows="6" placeholder="Type Your Message Here" required="Message is required" data-error="Write your message"></textarea>
                                                <div className="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <button type="submit" className="btn " title='' name="contact" style={{ backgroundColor: "#ff8a00", color: "white" }} >Send Message</button>
                                            <div id="msgSubmit" className="h3 text-center hidden"></div>
                                            <div className="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/* MAP....... */}

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contact